<template>
  <div class="tw-relative">
    <label :for="props.id" class="tw-sr-only">Search</label>
    <input
      :id="props.id"
      type="search"
      class="tw-h-10 tw-w-full tw-border-none tw-bg-white tw-py-2 tw-pl-9 tw-pr-4 tw-text-base tw-text-primary-grey-800 tw-shadow-none tw-outline-none focus:tw-ring-0"
      :name="props.name"
      :placeholder="props.placeholder"
      :data-test-id="props.dataTestId"
      @click.stop
      @input="emitSearch($event)"
    />
    <div
      class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3"
    >
      <ClIconTablerSearch
        :width="'20px'"
        :height="'20px'"
        class="tw-text-primary-grey-700"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ClIconTablerSearch } from "../icons";

export interface DropdownSearchProps {
  id?: string;
  name?: string;
  placeholder?: string;
  dataTestId?: string;
}

const props = withDefaults(defineProps<DropdownSearchProps>(), {
  id: "sidebar-dropdown-search",
  name: "sidebar-dropdown-search",
  dataTestId: "sidebar-dropdown-search",
  placeholder: "Search",
});

const emit = defineEmits<{
  (event: "search", phrase: string): void;
}>();

const emitSearch = (event: Event): void => {
  emit("search", (event.target as HTMLInputElement).value.trim());
};
</script>

<style scoped></style>
